<template>
  <div class="box_hd">
    <div class="box_hd_top">
      <span class="box_hd_top_title">{{title}}</span>

      <button class="box_hd_top_btn send" @click="sendhomework">发送作业</button>
      <button class="box_hd_top_btn" @click="quitShow=true">退出编辑</button>
      <button class="box_hd_top_btn scan" @click="GetCWxloginAGetwxqrcode">扫码分享</button>
    </div>
    <div class="hint-mask" v-if="quitShow">
      <div class="quithint">
        <p class="img-wrapper">
          <img src="./warning.png" alt="warning" width="50" height="50">
        </p>

        <p class="hint-text">退出之后，之前编辑的页面也将会消失，请谨慎处理！</p>
        <button class="cancel" @click="quitEdit">退出</button>
        <button class="confirm" @click="quitShow=false">再看看</button>
      </div>
    </div>
    <el-dialog
      title="扫码分享"
      :visible.sync="qrShow"
      width="30%">
      <p style="font-size:20px;line-height:36px;margin-bottom:20px;">请使用微信“扫一扫”打开全优在线小程序发送作业给家长</p>
      <img style="display: block;margin: 0 auto;" :src="qrurl" alt="二维码" width="250" height="250">
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      id: {
        type: String,
      },
      title: {
        type: String,
      },
      rid: {
        type: String,
      },
      lessonid: {
        type: String,
      },
      classid: {
        type: String,
      },
      homeworkid: {
        type: String,
      }
    },
    data() {
      return {
        quitShow:false,
        qrurl:'',
        qrShow:false
      }
    },
    methods:{
      quitEdit(){
        this.$router.replace('/console/homework/undone')
      },
      sendhomework(){
        this.$emit('sendhomework');
      },
      GetCWxloginAGetwxqrcode(){
        let params = {
          c: 'WxLogin',
          a: 'getWXQRCode',
          page: 'pages/sharefromweb/sharefromweb',
          // page: 'pages/workedit/workedit',
          scene:this.rid+'-'+this.lessonid+'-'+this.classid+'-'+this.homeworkid
        };

        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.qrShow=true;
            this.qrurl=response.QRCode;
          }
        }).catch((err) => {

        });
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .box_hd {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background :#fff
    .box_hd_top {
      height: 66px;
      border-bottom: 1px solid #e9e9e9
      .box_hd_top_title {
        float: left;
        padding-left: 20px;
        height: 66px;
        line-height: 66px;
        font-size: 20px;
        color: #333;
        font-weight: bold;
      }
      .box_hd_top_btn {
        float: right;
        margin: 10px 20px 0 0;
        display: inline-block;
        width: 140px;
        height: 46px;
        line-height: 46px;
        font-size: 16px;
        color: #333;
        border-radius: 4px;
        border: 1px solid #e9e9e9
        box-sizing: border-box
        &.send {
          text-align: left
          text-indent: 53px
          background: url('./send.png') no-repeat left 16px center / 22px 22px
        }
        &.scan{
          text-align: left
          text-indent: 53px
          background: url('./scancode.png') no-repeat left 16px center / 22px 22px
        }
      }
    }
    .box_hd_middle {
      height: 58px;
      overflow: hidden
      .box_hd_middle_text {
        font-size: 14px;
        color: #333;
        height: 58px;
        line-height: 58px;
        padding: 0 20px;
      }
      .box_hd_middle_name {
        display: inline-block;
        padding: 0 20px;
        height: 46px;
        line-height: 44px;
        font-size: 14px;
        color: #333;
        border-radius: 4px;
        border: 1px solid #e9e9e9;
        box-sizing: border-box
      }
    }
  }
  .hint-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.3)
    z-index: 1000
    font-size: 0
    &::after {
      content: "";
      display: inline-block;
      height: 100%;
      width: 0;
      vertical-align: middle;
    }
    .quithint {
      display: inline-block;
      padding: 40px 84px 0;
      width: 400px;
      height: 290px;
      vertical-align: middle;
      background-color: #fff;
      border-radius: 6px;
      overflow: hidden;
      box-sizing: border-box
      .img-wrapper {
        margin-bottom: 30px;
        height: 50px;
        text-align: center
      }
      .hint-text {
        margin-bottom: 30px;
        font-size: 14px;
        color: #a5a5a5;
        line-height: 22px;
      }
      .cancel, .confirm {
        display: inline-block;
        width: 106px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 15px;
        color: #fff;
        border-radius: 4px;
      }
      .cancel {
        margin-right: 20px;
        background: #ccc;
      }
      .confirm {
        background: #3399ff;
        &:hover {
          background: #5eaefe
        }
      }
    }
    .sendhint {
      display: inline-block;
      padding: 40px 0 0;
      width: 400px;
      height: 290px;
      vertical-align: middle;
      background-color: #fff;
      border-radius: 6px;
      overflow: hidden;
      box-sizing: border-box
      .img-wrapper {
        margin-bottom: 20px;
        height: 50px;
        text-align: center
      }
      .send-title {
        font-size: 16px;
        color: #333;
        height: 22px;
        line-height: 22px;
        margin-bottom: 10px;
      }
      .hint-text {
        margin: 0 70px 20px;
        font-size: 14px;
        color: #a5a5a5;
        line-height: 22px;
      }
      .back-btn {
        display: inline-block;
        font-size: 15px;
        color: #fff;
        width: 250px;
        height: 36px;
        line-height: 36px;
        background: #3399ff;
        border-radius: 4px;
        &:hover {
          background: #5eaefe
        }
      }
      .cancel, .confirm {
        display: inline-block;
        width: 106px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 15px;
        color: #fff;
        border-radius: 4px;
      }
      .cancel {
        margin-right: 20px;
        background: #ccc;
      }
      .confirm {
        background: #3399ff;
        &:hover {
          background: #5eaefe
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/homework/tchattop.vue